export const MESSAGE_NAME = {
    TIME: 'time',
    EVENT_NORMAL: 'event_normal', // 普通事件
    EVENT_SOCKET: 'event_socket', // socket 状态
    EVENT_CHAT_NOTICE: 'event_chat_notice', // 分配客服
    INPUT_STATUS: 'input_status', // 客服输入事件
    READED: 'readed', //已读事件
    EVENT_CHAT_STATUS: 'event_chat_status', // 用户状态变更
    EVENT_QUEUE: 'event_queue', // 排队客户变更
    EVENT_WITHDRAW: 'event_withdraw', // 消息撤回事件
    EVENT_EVALUATION: 'event_evaluation', // 评价事件
    EVENT_LEAVE_MESSAGE: 'event_leave_message', // 留言事件
    EVENT_SESSION_MONITOR: 'event_session_monitor', // 触发敏感词汇事件
    TEXT: 'text', // 文本类型
    IMAGE: 'image', // 图片类型
    AUDIO: 'audio', // 音频
    AUDIO_TRANSLATION: 'audio_translation', // 微信音频的翻译为文字
    VIDEO: 'video', // 视频
    FILE: 'file', // file
    RICH_TEXT: 'rich_text', // 富文本，使用 iframe
    HTML: 'html', // 富文本 html标签渲染
    RENDER_TEXT: 'render_text', // render_text 个性化click文字渲染类型
    // todo: mode: satisfaction_degree 满意度
    OPTION_NORMAL: 'option_normal', // recommend mode: normal or options or no_answer
    // OPTION_SWIPER: 'option_swiper', // recommend mode: no_answer
    SELECT: 'select', // select，age: 年龄, money: 费用, date: 时间
    TABLE: 'table', // 表格类型(多维数组)
    SWIPER_ICON: 'swiper_icon', // card mode: small
    // SWIPER_SINGLE: 'swiper_single', // card mode: loop_recommends (去掉)
    SWIPER_IMG_TEXT: 'swiper_img_text', // card mode: full or full_recommend
    SWIPER_LIST: 'swiper_list', // card mode: general
    RECORDING: 'recording', // 录音ing
    RESPONSE_LOADING: 'response_loading', // 回复ing
    INVITE: 'invite', //会话邀请
    SHOWBTN: 'showBtn' //转人工按钮显示
}

/**
 * 不用于计算是否插入时间消息的消息类型
 */
export const INVALID_TIME_MESSAGE = [
    MESSAGE_NAME.RECORDING,
    MESSAGE_NAME.RESPONSE_LOADING
]

/**
 * 无操作，纯显示的事件消息
 */
export const NO_ACTION_MESSAGE = [
    MESSAGE_NAME.EVENT_NORMAL,
    MESSAGE_NAME.EVENT_WITHDRAW,
    MESSAGE_NAME.EVENT_CHAT_NOTICE
]
/**
 * 非消息列表中渲染的事件，即用于其他用途，如弹框
 */
export const NO_IN_LIST_MESSAGE = [
    MESSAGE_NAME.EVENT_CHAT_STATUS,
    MESSAGE_NAME.EVENT_WITHDRAW,
    MESSAGE_NAME.EVENT_EVALUATION,
    MESSAGE_NAME.EVENT_LEAVE_MESSAGE,
    MESSAGE_NAME.EVENT_SESSION_MONITOR,
    MESSAGE_NAME.INPUT_STATUS,
    MESSAGE_NAME.READED,
    MESSAGE_NAME.INVITE,
    MESSAGE_NAME.SHOWBTN
]

/**
 * 修改接待客服信息，需要更新接待客服昵称
 */
export const CHAT_NOTICE = [
    MESSAGE_NAME.EVENT_CHAT_NOTICE
]

/**
 * 系统消息类型，即不属于 SERVICE 和 USER
 */
export const SYSTEM_MESSAGE = [
    MESSAGE_NAME.TIME,
    MESSAGE_NAME.EVENT_NORMAL,
    MESSAGE_NAME.EVENT_CHAT_NOTICE,
    MESSAGE_NAME.EVENT_CHAT_STATUS,
    MESSAGE_NAME.EVENT_QUEUE,
    MESSAGE_NAME.EVENT_SOCKET
]

/**
 * 不具有头像的消息类型
 */
export const NO_AVATAR_MESSAGE = [
    MESSAGE_NAME.SWIPER
]

/**
 * 扩展功能
 */
export const EXTEND_TYPE = {
    TEXTS: 'text',
    IMG_TEXTS: 'imgText'
}

/**
 * 推荐消息的 mode
 */
export const RECOMMEND_TYPE = {
    NO_ANSWER: 'no_answer',
    NORMAL: 'normal',
    OPTIONS: 'options'
}

/**
 * 消息类型的状态，主要用于客户
 */
export const STATUS = {
    SENDING: 0,
    SUCCESS: 1,
    FAIL: -1
}

/**
 * 消息所属主体
 * @property { String } SERVICE - 客服：机器人和人工客服
 * @property { String } USER - 客户，即用户
 */
export const HOST = {
    SERVICE: 'service',
    USER: 'user'
}

/**
 * 消息发送方，与后端定义相同，可能 CHAT_USER 和 USER 会产生歧义，如上面的 HOST
 * 实时聊天的字段 from
 * @property { String } CHAT_USER - 客户（即用户）
 * @property { String } USER - 人工客服
 * @property { String } SYSTEM - 系统
 * @property { String } ROBOT - 机器人客服
 */
export const MESSAGE_FROM = {
    CHAT_USER: 'chat_user',
    USER: 'user',
    SYSTEM: 'system',
    ROBOT: 'robot'
}

/**
 * 消息发送方
 * 历史记录的字段 sender - 发送者，1为访客，2为机器人，3为客服，4为系统
 */
export const MESSAGE_SENDER = {
    1: MESSAGE_FROM.CHAT_USER,
    2: MESSAGE_FROM.ROBOT,
    3: MESSAGE_FROM.USER,
    4: MESSAGE_FROM.SYSTEM
}

/**
 * 消息的评分，专属于客服为机器人类型
 * @property { Number } UP - 已 up
 * @property { Number } DOWN - 已 down
 * @property { Number } NONE - 未评价
 */
export const EVALUATION_VALUE = {
    UP: 1,
    DOWN: -1,
    NONE: 0
}

/**
 * 用于 header 显示公司 名字 or Logo
 */
export const SHOW_COMPANY_LOGO_OR_NAME = {
    NAME: 'name',
    LOGO: 'logo',
    NONA: 'none'
}

/**
 * 聊天对象：人工 or 机器人
 */
export const CHAT_TARGET = {
    HUMAN: 'human',
    ROBOT: 'robot'
}
